import { EntranceImage } from 'apollo/types';
import {
  LocalizedEntranceTicketTypeBackOffice,
  TranslationLanguage,
} from 'apollo/localizedTypes';
import * as texts from 'assets/texts/localizedText';

const columns = (
  statusColumnRender: (value: boolean, record: unknown) => JSX.Element,
  editButton: (EditItem: LocalizedEntranceTicketTypeBackOffice) => JSX.Element,
  imageGroup: (item: EntranceImage[] | undefined) => JSX.Element,
  visibilityColumnRender: (value: boolean, record: unknown) => JSX.Element,
  renderTranslationsColumn: (missingTranslations: TranslationLanguage[]) => JSX.Element
) => {
  return [
    {
      title: 'Tipo de ticket',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: texts.translations,
      dataIndex: 'missingTranslations',
      key: 'missingTranslations',
      align: 'center' as const,
      render: renderTranslationsColumn,
    },
    {
      title: 'Precio adultos',
      dataIndex: 'adultValue',
      key: 'adultValue',
    },
    {
      title: 'Precio Adulto mayor o Niños < 4 años',
      dataIndex: 'otherValue',
      key: 'otherValue',
    },
    {
      title: 'Stock tickets diario',
      dataIndex: 'maxStock',
      key: 'maxStock',
    },
    {
      title: 'Fotos',
      dataIndex: 'entranceImages',
      key: 'entranceImages',
      render: imageGroup,
    },
    {
      title: 'Estado',
      dataIndex: 'status',
      key: 'status',
      render: statusColumnRender,
    },
    {
      title: 'Visibilidad',
      dataIndex: 'visibility',
      key: 'visibility',
      render: visibilityColumnRender,
    },
    {
      title: 'Acciones',
      dataIndex: 'actions',
      key: 'actions',
      render: editButton,
    },
  ];
};

export default columns;
